<template>
  <div id="view">
    <historyTag :historyArr="historyArr"></historyTag>
    <div id="mainBox">
      <div class="bannerList">
        <div class="topBox">
          <el-button type="success" size="small" @click="openAdd">新增</el-button>
        </div>
        <el-table border :data="tableData" class="bannerTable" style="width: 100%">
          <el-table-column align="center" label="图片" min-width="112">
            <template slot-scope="scope">
              <div class="thumb">
                <img v-if="scope.row.imageUrl" :src="scope.row.imageUrl" />
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="跳转目标" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.secondhandProductTitle">{{ scope.row.secondhandProductTitle }}</span>
              <span v-else class="hint">仅展示</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="sortOrder" label="排序" min-width="80" />
          <el-table-column align="center" label="状态" min-width="88">
            <template slot-scope="scope">
              <span>{{ scope.row.status === 1 ? '上架' : '下架' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="168" fixed="right">
            <template slot-scope="scope">
              <el-button type="success" size="small" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="delRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="720px"
        append-to-body
        :close-on-click-modal="false"
        @opened="onDialogOpened"
      >
        <el-form label-width="120px" class="dialogForm">
          <el-form-item label="图片" required>
            <div style="width: 240px; height: 140px">
              <elUpload @getImg="onImg" :image="form.imageUrl"></elUpload>
            </div>
          </el-form-item>
          <el-form-item label="关联商品">
            <el-select
              v-model="form.secondhandProductId"
              filterable
              remote
              reserve-keyword
              clearable
              :remote-method="onProductSearchRemote"
              :loading="productLoading"
              placeholder="选填；不选则首页仅展示图片，点击无跳转"
              style="width: 100%"
              @visible-change="onProductSelectVisible"
            >
              <el-option
                v-for="p in productOptions"
                :key="'p-' + p.id"
                :label="productOptionLabel(p)"
                :value="p.id"
              />
            </el-select>
            <div class="productMoreRow">
              <el-button
                type="text"
                size="small"
                :disabled="!productHasMore || productLoading"
                @click="loadMoreProductsForSelect"
              >
                {{ productHasMore ? "加载更多在售商品" : "已加载全部" }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="form.sortOrder" :min="0" :max="999999" />
            <span class="hint">数字越大越靠前</span>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="0">下架</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialogFooter">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="submitShow" @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import elUpload from "@/components/elUpload";
import { delTips, throttle } from "@/util/utils";

const LINK_NONE = 0;
const LINK_PRODUCT = 1;

export default {
  components: { elUpload },
  data() {
    return {
      historyArr: ["界面管理", "广告位"],
      tableData: [],
      submitShow: false,
      dialogVisible: false,
      dialogTitle: "",
      productOptions: [],
      productLoading: false,
      productPage: 1,
      productKeyword: "",
      productHasMore: false,
      productSearchTimer: null,
      productPageSize: 50,
      form: {
        id: null,
        imageUrl: "",
        secondhandProductId: null,
        sortOrder: 0,
        status: 1,
      },
    };
  },
  mounted() {
    this.loadList();
  },
  beforeDestroy() {
    if (this.productSearchTimer) {
      clearTimeout(this.productSearchTimer);
      this.productSearchTimer = null;
    }
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        imageUrl: "",
        secondhandProductId: null,
        sortOrder: 0,
        status: 1,
      };
    },
    productOptionLabel(p) {
      if (!p || p.id == null) return "";
      const t = String(p.title || "").trim().slice(0, 36);
      const price = p.price != null && p.price !== "" ? ` ¥${p.price}` : "";
      return `${t || "无标题"}${price}`;
    },
    onImg(url) {
      this.$set(this.form, "imageUrl", url);
    },
    loadList() {
      this.$https(
        this.$api.api.selHomeSecondhandBanner,
        { page: 1, size: -1 },
        "POST"
      ).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data || [];
        }
      });
    },
    onDialogOpened() {
      this.productKeyword = "";
      this.productPage = 1;
      this.productHasMore = false;
      this.fetchProductOptions({ page: 1, append: false });
    },
    onProductSelectVisible(visible) {
      if (visible && !this.productOptions.length && !this.productLoading) {
        this.fetchProductOptions({ page: 1, append: false });
      }
    },
    onProductSearchRemote(query) {
      const q = query != null ? String(query).trim() : "";
      if (this.productSearchTimer) {
        clearTimeout(this.productSearchTimer);
      }
      this.productSearchTimer = setTimeout(() => {
        this.productSearchTimer = null;
        this.productKeyword = q;
        this.productPage = 1;
        this.fetchProductOptions({ page: 1, append: false });
      }, 300);
    },
    loadMoreProductsForSelect() {
      if (!this.productHasMore || this.productLoading) return;
      this.fetchProductOptions({ page: this.productPage + 1, append: true });
    },
    fetchProductOptions({ page, append }) {
      if (this.productLoading) return;
      this.productLoading = true;
      const size = this.productPageSize;
      const body = { page, size, status: 1 };
      if (this.productKeyword) {
        body.title = this.productKeyword;
      }
      this.$https(this.$api.api.selSecondhandProduct, body, "POST")
        .then((res) => {
          const pageRows = res.data && res.data.code === 200 ? res.data.data || [] : [];
          let list = pageRows.slice();
          const pid = this.form.secondhandProductId;
          if (
            !append &&
            pid != null &&
            pid !== "" &&
            !list.some((x) => x && x.id === pid)
          ) {
            list = [
              {
                id: pid,
                title: "（当前绑定商品不在在售列表，请重新选择）",
                price: null,
                __bannerOrphan: true,
              },
              ...list,
            ];
          }
          if (append) {
            const seen = new Set();
            const merged = [];
            this.productOptions.forEach((x) => {
              if (x && x.id != null && !seen.has(x.id)) {
                seen.add(x.id);
                merged.push(x);
              }
            });
            list.forEach((x) => {
              if (x && x.id != null && !seen.has(x.id)) {
                seen.add(x.id);
                merged.push(x);
              }
            });
            this.productOptions = merged;
          } else {
            this.productOptions = list;
          }
          this.productPage = page;
          const total =
            res.data && res.data.size != null ? Number(res.data.size) : 0;
          if (total > 0) {
            const loadedServer = this.productOptions.filter(
              (x) => x && !x.__bannerOrphan
            ).length;
            this.productHasMore = loadedServer < total;
          } else {
            this.productHasMore = pageRows.length >= size;
          }
        })
        .finally(() => {
          this.productLoading = false;
        });
    },
    openAdd() {
      this.dialogTitle = "新增广告位";
      this.form = this.emptyForm();
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogTitle = "编辑广告位";
      this.form = {
        id: row.id,
        imageUrl: row.imageUrl || "",
        secondhandProductId: row.secondhandProductId,
        sortOrder: row.sortOrder != null ? row.sortOrder : 0,
        status: row.status != null ? row.status : 1,
      };
      this.dialogVisible = true;
    },
    submit: throttle(function () {
      if (!this.form.imageUrl) {
        this.$message.error("请上传轮播图");
        return;
      }
      const pid = this.form.secondhandProductId;
      const hasProduct = pid !== null && pid !== undefined && pid !== "";
      const payload = {
        imageUrl: this.form.imageUrl,
        linkType: hasProduct ? LINK_PRODUCT : LINK_NONE,
        sortOrder: this.form.sortOrder,
        status: this.form.status,
        secondhandProductId: hasProduct ? Number(pid) : null,
        externalUrl: null,
      };
      if (this.form.id) {
        payload.id = this.form.id;
      }
      const url = this.form.id
        ? this.$api.api.upHomeSecondhandBanner
        : this.$api.api.addHomeSecondhandBanner;
      this.submitShow = true;
      this.$https(url, payload, "POST")
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.loadList();
          } else {
            this.$message.error(res.data.msg || "失败");
          }
        })
        .finally(() => {
          this.submitShow = false;
        });
    }, 800),
    delRow: delTips(function (row) {
      this.$https(
        this.$api.api.delHomeSecondhandBanner,
        { id: row.id },
        "GET"
      ).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("已删除");
          this.loadList();
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      });
    }),
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}
.topBox {
  margin-bottom: 12px;
  text-align: right;
}
.bannerTable /deep/ table {
  table-layout: fixed;
  width: 100%;
}
.bannerTable /deep/ .el-table__cell {
  vertical-align: middle;
}
.thumb {
  width: 96px;
  height: 54px;
  margin: 0 auto;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f7f9;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}
.dialogForm {
  max-width: 100%;
}
.dialogFooter {
  text-align: right;
}
.hint {
  margin-left: 8px;
  color: #999;
  font-size: 12px;
}
.productMoreRow {
  margin-top: 4px;
  line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// src/pages/homeSecondhandBanner/index.vue